export default "__VITE_ASSET__Djuf00xO__"